module.exports = __webpack_public_path__ + "static/criteo-a6c9e19008584095346369fb247ece14.jpg";